// libs
import React, { useState } from 'react';
import { useForm } from "react-hook-form";
import { ToastContainer, toast } from 'react-toastify';
import "../../assets/css/form.css";
import Container from 'react-bootstrap/Container';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
import Button from 'react-bootstrap/Button';
import Modal from 'react-bootstrap/Modal';
// config & functions 
import ajaxCall from '../../utils/ajaxcall';
import config from "../../config/index";

function FormModal({loadapidata, setshowformmodalbox, orgaccountid, rowid, token, orginfo}) {

    const [InputFields, setInputFields] = useState({
        rowId: "",
        label: "",
        sortOrder: 0,
        isActive: 1,
        slug: ""
    });
    // Top-level categories that can be chosen as parent (e.g. a brand for a model)
    const [ParentList, setParentList] = useState([]);
    const [ParentId, setParentId] = useState("");
    const [HasChildren, setHasChildren] = useState(false);
    const disabledField = (orginfo.roleId === 1 || orginfo.roleId === 2) ? false : true;
    const [SubmitButton, setSubmitButton] = useState((rowid) ? 'UPDATE RECORD' : 'SAVE RECORD');
    const [Notification, setNotification] = useState({ status: (rowid) ? true : false, message: 'Please wait while we fetch your record' });
    const [DisableSubmitButton, setDisableSubmitButton] = useState(false);
    const [Show, setShow] = useState(false);

    const {
        register,
        handleSubmit,
        control,
        formState: { errors },
        reset
    } = useForm();

    const hideModal = () => {
        setShow(false);
        setshowformmodalbox(false);
    }

    const updateChangeEvent = (value, field) => {
        if (value && value.target != null) {
            field.onChange(value.target.value);
        } else {
            field.onChange(value);
        }
    }

    const onSubmit = async (data) => {
        if (!orgaccountid) {
            toast.error('Choose a seller account on the list page first');
            return;
        }
        setSubmitButton('LOADING...');
        setDisableSubmitButton(true);
        let postData = {
            accountId: orgaccountid,
            rowId: rowid || 0,
            label: data.label,
            parentId: ParentId || "",
            sortOrder: data.sortOrder ?? 0,
            isActive: data.isActive ? 1 : 0
        };
        let apiCall = "";
        if (InputFields.rowId) {
            apiCall = await ajaxCall.patchCall(`${config.api.generic}/category`, postData, token);
        } else {
            apiCall = await ajaxCall.postCall(`${config.api.generic}/category`, postData, token);
        }
        if (apiCall && apiCall.status) {
            setSubmitButton((InputFields.rowId) ? 'UPDATE RECORD' : 'SAVE RECORD');
            toast.info('Record updated successfully');
            reset();
            setDisableSubmitButton(false);
            hideModal();
            loadapidata();
        } else {
            setSubmitButton((InputFields.rowId) ? 'UPDATE RECORD' : 'SAVE RECORD');
            toast.error(apiCall && apiCall.context.message || 'Something went wrong. Please try again :(');
            setDisableSubmitButton(false);
        }
    }

    React.useEffect(() => {
        async function loadComponent() {
            setShow(true);
        }

        async function fetchParents() {
            if (!orgaccountid) return;
            let apiCall = await ajaxCall.getCall(`${config.api.generic}/category`, { fAccount: orgaccountid }, token);
            const records = (apiCall && apiCall.status && apiCall.context.message.data?.records) || [];
            setParentList(records.filter(d => !d.fk_parent_id && String(d.pk_id) !== String(rowid || '')));
            setHasChildren(Boolean(rowid) && records.some(d => String(d.fk_parent_id) === String(rowid)));
        }

        async function fetchData() {
            if (rowid) {
                let apiCall = await ajaxCall.getCall(`${config.api.generic}/category/row`, {
                    rowId: rowid
                }, token);
                if (apiCall && apiCall.status) {
                    let d = apiCall.context.message.data[0];
                    setInputFields({
                        rowId: rowid,
                        label: d.label,
                        sortOrder: d.sort_order,
                        isActive: parseInt(d.is_active),
                        slug: d.slug
                    });
                    setParentId(d.fk_parent_id ? String(d.fk_parent_id) : "");
                    setNotification({ status: false });
                } else {
                    setNotification({ status: true, message: 'Sorry something went wrong while fetching record :(' });
                }
            }
        }
        fetchParents();
        fetchData();
        loadComponent();
    }, []);

    return (
        <>
            <Modal show={Show} size="lg" aria-labelledby="contained-modal-title-vcenter" centered>
                <Modal.Header>
                    <Modal.Title>{rowid ? 'Update Category' : 'Add Category'}</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <Container>
                        <Row>
                            <form action="" method="" className="p-sm-1" onSubmit={handleSubmit(onSubmit)}>
                                <Row>
                                    {(Notification.status) ? <Col md="12" className="text-center">{Notification.message}</Col> : <>
                                        <Col md="12">
                                            <div className="text-left mt-3 vt-txt-dark-blue">
                                                <h4><b>Category Info</b></h4>
                                                <hr />
                                            </div>
                                        </Col>
                                        <Col md="8" className="mt-3">
                                            <label className="form-label fs-14rem fw-bold">Category Name</label>
                                            <input type="text" defaultValue={InputFields.label} className="form-control" {...register("label", { required: true, minLength: 1, maxLength: 64 })} disabled={disabledField} placeholder="e.g. Helmets, Riding Gear" />
                                            <small className="form-text text-danger">
                                                {errors.label?.type === "required" && "Category name is mandatory"}
                                            </small>
                                        </Col>
                                        <Col md="12" className="mt-3">
                                            <label className="form-label fs-14rem fw-bold">Parent Category</label>
                                            <select value={ParentId} onChange={(e) => setParentId(e.target.value)} className="form-control custom-select" disabled={disabledField || HasChildren}>
                                                <option value="">None (top-level category)</option>
                                                {ParentList.map(d => <option key={d.pk_id} value={d.pk_id}>{d.label}</option>)}
                                            </select>
                                            <small className="form-text text-muted">
                                                {HasChildren
                                                    ? 'This category has sub-categories, so it must stay top-level.'
                                                    : 'Choose a parent to make this a sub-category, e.g. parent "KTM" for "Duke 390".'}
                                            </small>
                                        </Col>
                                        <Col md="4" className="mt-3">
                                            <label className="form-label fs-14rem fw-bold">Sort Order</label>
                                            <input type="number" defaultValue={InputFields.sortOrder} className="form-control" {...register("sortOrder")} disabled={disabledField} placeholder="0" />
                                            <small className="form-text text-muted">Lower numbers appear first in nav</small>
                                        </Col>
                                        {InputFields.slug ? <Col md="12" className="mt-2">
                                            <small className="text-muted">Store URL slug: <code>{InputFields.slug}</code> (updates when name changes)</small>
                                        </Col> : null}
                                        <Col md="12" className="mt-3 d-flex align-items-end">
                                            <div className="form-check">
                                                <input type="checkbox" defaultChecked={InputFields.isActive} className="form-check-input" {...register("isActive")} disabled={disabledField} />
                                                <label className="form-check-label fs-14rem fw-bold">Show on website navigation</label>
                                            </div>
                                        </Col>
                                        {(orginfo.roleId === 1 || orginfo.roleId === 2) ? <Col md="12" className="text-end">
                                            <Button variant="primary" type="submit" disabled={DisableSubmitButton} className="vt-primary-btn border-0 text-end text-white mt-4 fs-14rem">{SubmitButton}</Button>
                                        </Col> : null }
                                    </>}
                                </Row>
                            </form>
                        </Row>
                    </Container>
                </Modal.Body>
                <Modal.Footer>
                    <Button variant="secondary" className="fs-14rem" onClick={hideModal}>Close</Button>
                </Modal.Footer>
            </Modal>
            <ToastContainer
                position="top-right"
                autoClose={5000}
                hideProgressBar={false}
                newestOnTop={false}
                closeOnClick
                rtl={false}
                pauseOnFocusLoss
                draggable
                pauseOnHover
            />
        </>
    )
}

export default FormModal;
